export default __webpack_public_path__ + "static/media/logo.da75b6b8.svg";